<template>
  <v-form ref="form">
    <div class="mb-8">
      <h4 class="title-type-3">
        모드
        <v-tooltip right content-class="tooltip-custom-1">
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="ml-2" v-bind="attrs" v-on="on"
              >mdi-alert-circle-outline</v-icon
            >
          </template>
          <span>모드: 스트로크|챔피언십(대회)</span>
        </v-tooltip>
      </h4>
      <div class="relative white rounded pa-6 pr-16">
        <div class="form-row-1">
          <p class="label">
            모드 선택
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </p>
          <div class="write-con">
            <v-select
              :items="modes"
              label="선택"
              v-model="mode"
              item-text="name"
              item-value="client_key"
              item-color="#000"
              class="input-custom-2"
              height="40px"
              solo
              required
              hide-details
            ></v-select>
          </div>
        </div>
        <div class="form-row-1 mt-4" v-if="mode === 'championship'">
          <p class="label">
            대회ID
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </p>
          <div class="write-con">
            <v-text-field
              v-model="competitionId"
              label="대회 아이디 값을 직접 입력해주세요."
              class="input-custom-2"
              height="40px"
              solo
              :rules="[rules.required, rules.isNumber]"
              required
            ></v-text-field>
            <p class="form-coment-1 mt-n2">
              <v-icon>mdi-alert-circle-outline</v-icon>
              숫자만 가능합니다.
            </p>
          </div>
        </div>
      </div>
    </div>
    <div ref="form" class="mb-8">
      <h4 class="title-type-3">
        CC 코스
        <v-tooltip right content-class="tooltip-custom-1">
          <template v-slot:activator="{ on, attrs }">
            <v-icon class="ml-2" v-bind="attrs" v-on="on"
              >mdi-alert-circle-outline</v-icon
            >
          </template>
          <span
            >CC 코스: (전체 | 그룹 | 지정) CC 1개 지정 CC의 경우 DB에서
            택1</span
          >
        </v-tooltip>
      </h4>
      <div class="relative white rounded pa-6 pr-16">
        <div class="form-row-1">
          <p class="label">
            CC선택
            <span class="required">
              <v-icon>mdi-check-circle-outline</v-icon>
              필수
            </span>
          </p>
          <div class="write-con">
            <div class="d-flex">
              <div style="height: 48px">
                <v-radio-group
                  v-model="courseType"
                  class="mt-0 pt-2"
                  :rules="[rules.required]"
                  row
                  hide-details
                >
                  <v-radio
                    v-if="mode !== 'championship'"
                    label="전체 CC"
                    value="all"
                    color="#fecd00"
                    class="radio-type-1 mr-10"
                  ></v-radio>
                  <v-radio
                    v-if="mode !== 'championship'"
                    label="그룹 CC"
                    value="group"
                    color="#fecd00"
                    class="radio-type-1 mr-10"
                  ></v-radio>
                  <v-radio
                    label="지정 CC"
                    value="one"
                    color="#fecd00"
                    class="radio-type-1"
                  ></v-radio>
                </v-radio-group>
              </div>
              <template v-if="courseType === 'group'">
                <v-select
                  label="그룹 CC를 선택해주세요."
                  v-model="courseGroup"
                  :items="courseGroupList"
                  item-text="name"
                  item-color="#000"
                  class="input-custom-2"
                  height="40px"
                  solo
                  required
                  return-object
                  no-data-text="그룹 CC가 없습니다."
                  :rules="[rules.required]"
                ></v-select>
              </template>
              <template v-else-if="courseType === 'one'">
                <div class="relative">
                  <div class="search-1">
                    <span class="readinput" style="width: 350px">
                      <v-text-field
                        class="input-custom-2"
                        height="40px"
                        min-width="300px"
                        :value="course ? course.name : null"
                        :rules="[rules.required]"
                        solo
                        readonly
                        @click.stop="showModal = true"
                      />
                    </span>
                    <v-btn
                      depressed
                      large
                      max-height="40px"
                      color="#fecd06"
                      class="button-type-1 ml-2"
                      @click.stop="showModal = true"
                    >
                      찾기
                    </v-btn>
                    <v-btn
                      depressed
                      large
                      max-height="40px"
                      color="#fff"
                      class="button-type-1 ml-2"
                      @click.stop="selectCourse(null)"
                    >
                      취소
                    </v-btn>
                    <v-checkbox
                      v-model="useXml"
                      label="XML 사용여부"
                      color="#fecd00"
                      off-icon="mdi-checkbox-blank"
                      class="checkbox-type-1 ml-5 pt-2"
                      hide-details
                    />
                  </div>
                </div>
              </template>
            </div>
            <v-chip-group column v-if="courseType === 'group' && courseGroup">
              <v-chip
                v-for="course in courseGroup.courses"
                :key="course.id"
                outlined
                >{{ course.name }}</v-chip
              >
            </v-chip-group>
          </div>
        </div>
      </div>
      <SearchCourseModal
        ref="searchModal"
        v-model="showModal"
        :propCourse="course"
        :courseList="courseList"
        @select:course="selectCourse"
      />
    </div>
  </v-form>
</template>

<script>
import SearchCourseModal from '~@/modal/v2/SearchCourseModal.vue';
import { listCourse, listCourseGroup } from '@/api/courses';
import _ from 'lodash';

export default {
  props: { propLineItem: Object, propOption: Object },
  components: { SearchCourseModal },
  data: () => ({
    rules: {
      required: v => !!v || '필수 항목입니다.',
      isNumber: v => (!!v && /^[0-9]+$/.test(v)) || '숫자만 가능합니다.',
    },

    modes: [],
    mode: null,
    competitionId: null,

    courseType: '',
    showModal: false,
    courseList: [],
    course: null,
    useXml: true,

    courseGroupList: [],
    courseGroup: null,
  }),
  methods: {
    validate() {
      if (!this.$refs.form.validate()) return false;

      if (this.mode === 'stroke') {
        if (this.courseType === 'all') return true;
        else if (this.courseType === 'group') return !!this.courseGroup;
        else if (this.courseType === 'one') return !!this.course;
      } else if (this.mode === 'championship') {
        return (
          !!this.competitionId && this.courseType === 'one' && !!this.course
        );
      }

      return false;
    },
    getValues() {
      const values = { mode: this.mode };
      if (this.mode === 'championship') {
        values['competition_id'] = this.competitionId;
      }

      if (this.courseType === 'group') {
        values['course_group_id'] = this.courseGroup.id;
      } else {
        values['cc_id'] =
          this.courseType === 'one' ? [this.course.cc_id] : null;
      }

      if (this.useXml) {
        values['use_xml'] = this.useXml;
      }

      return values;
    },

    selectCourse(course) {
      this.showModal = false;
      this.course = course;
    },

    async setCCInfo() {
      if (!this.propLineItem) return;
      await Promise.all([this.getCourseList(), this.getCourseGroupList()]);

      this.initJsonData();
    },
    async getCourseList() {
      try {
        const { data } = await listCourse(true);
        this.courseList = data.list;
      } catch (error) {
        console.log(error.response);
      }
    },
    async getCourseGroupList() {
      try {
        const { data } = await listCourseGroup();
        this.courseGroupList = data.list.filter(g => g.is_valid === 'Y');
      } catch (error) {
        console.log(error.response);
      }
    },
    initJsonData() {
      this.mode = _.get(this.propLineItem, 'json.mode');
      this.competitionId = _.get(this.propLineItem, 'json.competition_id');
      this.useXml = _.get(this.propLineItem, 'json.use_xml');

      const groupId = _.get(this.propLineItem, 'json.course_group_id');
      if (groupId) {
        this.courseType = 'group';
        this.courseGroup = this.courseGroupList.find(g => g.id === groupId);
      } else {
        const ccId = _.get(this.propLineItem, 'json.cc_id[0]');
        if (ccId) {
          this.courseType = 'one';
          this.course = this.courseList.find(c => c.cc_id === ccId);
        } else {
          this.courseType = 'all';
        }
      }
    },
  },
  watch: {
    propLineItem: {
      deep: true,
      immediate: true,
      handler() {
        this.initJsonData();
      },
    },
    mode: {
      immediate: true,
      handler() {
        if (this.mode === 'championship') {
          this.courseType = 'one';
        }
      },
    },
    course: {
      deep: true,
      handler() {
        this.useXml = true;
      },
    },
    courseType: {
      immediate: true,
      handler() {
        this.useXml = false;
        if (this.courseType === 'one') {
          this.useXml = _.get(this.propLineItem, 'json.use_xml', true);
        }
      },
    },
  },
  created() {
    this.modes = this.propOption.items;
    this.setCCInfo();
  },
};
</script>
